import type AttendeeType from 'owa-service/lib/contract/AttendeeType';

export default function isRecipientDistributionList(recipient: AttendeeType): boolean {
    const mailboxType = recipient.Mailbox?.MailboxType;

    return mailboxType == 'PrivateDL' || mailboxType == 'PublicDL' || mailboxType == 'GroupMailbox';
}
